import { IMAGE_TYPES, SAFE_VIDEO_TYPES, VIDEO_TYPES, SAFE_AUDIO_TYPES } from './file-format';

export default function loadResource(url, file) {
    const type = file.type;
    return new Promise((resolve, reject) => {
        if(IMAGE_TYPES.includes(type)) {
            const image = new Image();
            // TODO: ios 10 不允许本地图片带 crossOrigin
            if(url.includes('http://') || url.includes('https://')) {
                image.crossOrigin = 'Anonymous';
            }
            image.onload = () => resolve(image);
            image.onerror = (e) => reject(e.message ? e : new Error('加载失败，可能为非法类型图片 ' + url));
            image.src = url;
        }
        else if(SAFE_VIDEO_TYPES.includes(type)) {
            const video = document.createElement('video');
            video.crossOrigin = 'anonymous';

            video.onloadeddata = () => {
                video.width = video.videoWidth;
                video.height = video.videoHeight;
                resolve(video);
            };
            video.onerror = () => {
                reject(new Error('文件加载失败'));
            };
            video.src = url;
        }
        else if(SAFE_AUDIO_TYPES.includes(type)) {
            const audio = document.createElement('audio');
            audio.crossOrigin = 'anonymous';

            audio.onloadeddata = () => {
                audio.width = 156;
                audio.height = 88;
                resolve(audio);
            };
            audio.onerror = () => {
                reject(new Error('文件加载失败'));
            };
            audio.src = url;
        }
        else if(VIDEO_TYPES.includes(type)) {
            // 不支持的视频, 无法在浏览器里加载, 模拟一个假的 video 元素
            const vitualVideo = {
                isUnsupportedVideo: true,
                width: 100,
                height: 100,
            };
            resolve(vitualVideo);
        }
        else {
            reject(new Error('未知文件类型'));
        }
    });
};

export function loadResourceByFile(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
            resolve(reader.result);
        };

        reader.onerror = () => {
            reject(new Error('File load error'));
        };
        reader.readAsDataURL(file);
    })
        .then((url) => {
            return loadResource(url, file);
        });
}
